import { Trophy, Play, BarChart3, DollarSign } from 'lucide-react'
import { getMatchTypeLabels } from '../utils/matchTypeLabels'
import './BottomTabs.css'

const baseTabs = [
  { key: 'match', icon: Trophy },
  { key: 'rounds', label: 'Scores', icon: Play },
  { key: 'leaderboard', label: 'Leaders', icon: BarChart3 },
  { key: 'money', label: 'Money', icon: DollarSign },
]

export default function BottomTabs({ currentView, onNavigate, matchType }) {
  const labels = getMatchTypeLabels(matchType)

  return (
    <nav className="bottom-tabs">
      {baseTabs.map(({ key, label, icon: Icon }) => (
        <button
          key={key}
          className={`bottom-tab ${currentView === key ? 'active' : ''}`}
          onClick={() => onNavigate(key)}
        >
          <Icon size={22} />
          <span>{key === 'match' ? labels.tabLabel : label}</span>
        </button>
      ))}
    </nav>
  )
}
